import React from 'react';
import PropTypes from 'prop-types';
import LabelIndicator from '../label-indicator/LabelIndicator';
import toast from '../../toast';

const LabelList = ({
  labels,
  assessmentId,
  assessmentTitle,
  updateLabelAssociations,
  type,
  onLabelRemoved,
}) => {
  const removeLabelHandler = async (
    labelId,
    assessmentId,
    assessmentTitle,
    type,
    updateLabelAssociations,
  ) => {
    const filteredArray = labels.filter((item) => item?.labelId !== labelId);
    const labelIds = filteredArray.map((item) => item.labelId);
    const resourceTypes = type === 'video' ? 'video' : 'assessments';
    const response = await updateLabelAssociations(
      resourceTypes,
      assessmentId,
      labelIds,
    );
    if (response.success) {
      toast(`Your labels have been updated for ${assessmentTitle}`);
      onLabelRemoved(assessmentId, labelId);
    }
  };
  return (
    <div className="flex flex-wrap overflow-hidden">
      {labels.length > 0 &&
        labels.map((label) => {
          const labelId = label?.labelId;
          return labelId ? (
            <LabelIndicator
              key={label?.labelId}
              {...label}
              assessmentTitle={assessmentTitle}
              removeLabelHandler={async () =>
                removeLabelHandler(
                  labelId,
                  assessmentId,
                  assessmentTitle,
                  type,
                  updateLabelAssociations,
                )
              }
            />
          ) : null;
        })}
    </div>
  );
};

LabelList.propTypes = {
  labels: PropTypes.array.isRequired,
  assessmentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  assessmentTitle: PropTypes.string.isRequired,
  updateLabelAssociations: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  onLabelRemoved: PropTypes.func.isRequired,
};

LabelList.defaultProps = {
  labels: [],
  assessmentId: '',
  assessmentTitle: '',
  updateLabelAssociations: () => {},
  type: '',
  onLabelRemoved: () => {},
};

export default LabelList;
